import { pairLinks } from '../../../ui/tiles/pair-links';
import { LinkTileAdapter } from '../../../ui/tiles/LinkTileAdapter';
import { ImageTileAdapter } from '../../../ui/tiles/ImageTileAdapter';
import { sortByWeightAndAlphabetical } from '../utils/sort-by-weight-and-alphabetical';
import c from '../category-new.module.scss';

export const PopularLinks = ({ links, categoryId, allCategories }) => {
  const pinnedLinks = links
    .map((link) => {
      const currentFoundCategory = link.categories?.find(
        (category) => category.id === categoryId
      );
      const isPinned = Boolean(currentFoundCategory?.pinned);

      if (!isPinned) return null;

      return {
        ...link,
        _pinnedWeight: currentFoundCategory.weight ?? 10,
      };
    })
    .filter((link) => link !== null);

  const sortedPinnedLinks = sortByWeightAndAlphabetical({
    list: pinnedLinks,
    weightKey: '_pinnedWeight',
    alphabeticalKey: 'name',
  });

  const hasPinnedLinks = pinnedLinks.length > 0;

  if (!hasPinnedLinks) {
    return null;
  }

  const renderableLinks = pairLinks(sortedPinnedLinks);

  return (
    <div className={c.contentSection}>
      <h2 className={c.subheading}>Popular links</h2>
      <div className={c.tilesContainer}>
        {renderableLinks.map((renderable, renderableIndex) => {
          if (renderable.renderType === 'single') {
            const { item } = renderable;
            return (
              <ImageTileAdapter
                entity={item}
                allCategories={allCategories}
                key={`popular-single-${renderableIndex}`}
              />
            );
          }

          const { items } = renderable;
          const isPair = items.length === 2;

          return (
            <div className={c.tilePair} key={`popular-pair-${renderableIndex}`}>
              {items.map((item, itemIndex) => (
                <LinkTileAdapter
                  entity={item}
                  allCategories={allCategories}
                  className={isPair ? c.grow : undefined}
                  key={`popular-link-${renderableIndex}-${itemIndex}`}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
